/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-handler-names */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
import classNames from "classnames";

// Components
import Modal from "components/atoms/Modal";

// Icons
import ArrowBackIcon from "assets/icons/glory/arrow-back.svg?react";
import CloseIcon from "assets/icons/glory/close.svg?react";

// Hooks
import useTranslate from "hooks/useTranslate";

// Types
import { PAYMENT_STEPS } from "types/PaymentMethodsTypes";
import { ModalSize } from "types/modal";

import "./styles.sass";

type MainModalProps = {
  className?: string;
  children: React.ReactNode;
  isOpened: boolean;
  isStepBack?: boolean;
  title: string | React.ReactNode;
  balance?: string;
  paymentType?: string;
  paymentMethod?: string;
  paymentStep?: keyof typeof PAYMENT_STEPS;
  isTitleCenter?: boolean;
  size?: ModalSize;
  onBack?: () => void;
  onClose: () => void;
  hiddenOverflow?: boolean;
  classNameRoot?: string;
  classNameContent?: string;
};

const MainModal = (props: MainModalProps) => {
  const {
    className,
    children,
    isOpened,
    isStepBack = false,
    title,
    balance,
    paymentType,
    paymentStep,
    paymentMethod,
    isTitleCenter = true,
    onBack,
    onClose,
    size = ModalSize.BIG,
    hiddenOverflow = false,
    classNameRoot,
    classNameContent,
  } = props;
  const t = useTranslate();

  const classModal = classNames("MainModal", classNameRoot, {
    MainModal_small: size === ModalSize.SMALL,
    MainModal_huge: size === ModalSize.HUGE,
    MainModal_hiddenOverflow: hiddenOverflow,
  });

  const classModalHeader = classNames({
    "MainModal-header": true,
    "MainModal-header-left": !isTitleCenter,
    "MainModal-header-exception":
      paymentStep === PAYMENT_STEPS.PAYMENT_PAGE && paymentMethod === "corefy",
  });
  const classModalTitle = classNames({
    "MainModal-header__title": true,
    "MainModal-header__title_pay": !!paymentType,
    "MainModal-header__title_huge": size === ModalSize.HUGE,
    "MainModal-header__title_small": size === ModalSize.SMALL,
  });
  const classModalContent = classNames(className, classNameContent, {
    MainModal__content: true,
    MainModal__content_small: size === ModalSize.SMALL,
    MainModal__content_huge: size === ModalSize.HUGE,
    MainModal__content_exception:
      paymentStep === PAYMENT_STEPS.PAYMENT_PAGE && paymentMethod === "corefy",
  });

  const handleClose = () => {
    if (isOpened) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpened} className={classModal}>
      <div className="MainModal__wrapper">
        <div className={classModalHeader}>
          <button className="MainModal-header_back" onClick={onBack}>
            {isStepBack && <ArrowBackIcon />}
          </button>
          <div className={classModalTitle}>
            {/* eslint-disable-next-line no-nested-ternary */}
            {balance && !paymentMethod
              ? `${t("payment.header.balance")} ${balance}`
              : typeof title === "string"
                ? t(title)
                : title}
          </div>
          <button className="MainModal-header_close" onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
        <div className={classModalContent}>{children}</div>
      </div>
    </Modal>
  );
};

export default MainModal;
